import { SharedLibraryAssets } from './types/shared-library.types';

import leftArrowDisabledIcon from './assets/left-arrow-disabled-icon.svg';
import leftArrowIcon from './assets/left-arrow-icon.svg';
import rightArrowIcon from './assets/right-arrow-icon.svg';
import crossIcon from './assets/cross-icon.svg';
import successIcon from './assets/success.svg';
import attentionIcon from './assets/attention-icon.svg';
import exitWarning from './assets/exit-warning.svg';
import calendarIcon from './assets/calendar.svg';
import failureIcon from './assets/failure.svg';
import tickButton from './assets/tick.svg';
import rightArrowDisabledIcon from './assets/right-arrow-disabled.svg';

export const SHARED_LIBRARY_ASSETS: SharedLibraryAssets = {
  CALENDAR_ICON: calendarIcon,
  ATTENTION_ICON: attentionIcon,
  LEFT_ARROW_DISABLED_ICON: leftArrowDisabledIcon,
  LEFT_ARROW_ICON: leftArrowIcon,
  RIGHT_ARROW_ICON: rightArrowIcon,
  RIGHT_ARROW_DISABLED_ICON: rightArrowDisabledIcon,
  CROSS_ICON: crossIcon,
  SUCCESS_ICON: successIcon,
  EXIT_WARNING: exitWarning,
  FAILURE_ICON: failureIcon,
  TICK_BUTTON: tickButton,
};
